module.exports = "../../app/cells/components/related_contests_item/show.erb";